import {Utils} from "@digintent/pn-highlight-lib";

class Reporter {
	frame: HTMLIFrameElement;
	isReady: boolean = false;

	constructor() {
		window.addEventListener("message", (event: MessageEvent<{type: "PN_GTAG_READY"}>) => {
			if (event.data?.type === "PN_GTAG_READY")
				this.isReady = true;
		});
	}

	getFrame(integration: string): HTMLIFrameElement {
		if (this.frame)
			return this.frame;
		this.frame = document.createElement("iframe");

		const url = new URL(LEO.urls.www + "integration/reporter");
		url.searchParams.set("integration", integration);

		// See: https://developers.google.com/analytics/devguides/collection/ga4/reference/config
		url.searchParams.set("url", document.location.toString().substring(0, 1000));
		url.searchParams.set("title", document.title.substring(0, 300));
		url.searchParams.set("referrer", document.referrer.toString().substring(0, 420));

		this.frame.setAttribute("src", url.toString());

		this.frame.style.display = "none";
		return this.frame;
	}

	// Record a Google Analytics event.
	// E.g. `Reporter.gtag("event", "purchase", {transaction_id: "T001", value: 49.99});`
	// See: https://developers.google.com/analytics/devguides/collection/ga4/reference/events?client_type=gtag
	gtag: ((...args: any[]) => void) = async (...args) => {
		await Utils.Async.waitUntil(() => this.isReady);

		const message = {
			type: "PN_GTAG",
			args
		};

		this.frame.contentWindow?.postMessage(message, LEO.urls.www);
	};
}

export default new Reporter();
